import React from "react";

export const Divider = ({ dividerColor = "cui-bg-fg-minimal" }) => (
    <div className={`cui-w-1px cui-h-md ${dividerColor}`}>&nbsp;</div>
);
